import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-btb',
  templateUrl: './btb.component.html',
  styleUrls: ['./btb.component.css']
})
export class BtbComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
